module.exports = __webpack_public_path__ + "assets/img/5b6d-sj.svg";